import { createFileRoute } from "@tanstack/react-router";
import { JobDetail } from "../../features/runs/job-detail";

export const Route = createFileRoute("/_authed/$org/$project/jobs/$name/$tab")({ component: JobPage });

function JobPage() {
  const { org, project, name, tab } = Route.useParams();
  return <JobDetail scope={{ org, project }} name={name} tab={tab} />;
}
